interface ThemeDocumentTransitionInput {
	animate: boolean;
	currentTheme: string | undefined;
	resolvedTheme: string;
}

/**
 * iOS browsers all use WebKit. On affected Safari/WebKit releases, changing
 * theme-color after document load updates the DOM but not the browser chrome.
 * A real document refresh is the only observable, deterministic resample.
 */
export function isIosWebKit(): boolean {
	if (typeof navigator === 'undefined') return false;
	const mobileApple = /iP(?:hone|ad|od)/.test(navigator.userAgent);
	const desktopClassIpad = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
	return (mobileApple || desktopClassIpad) && /AppleWebKit/.test(navigator.userAgent);
}

export function shouldUseIosDocumentThemeTransition(input: ThemeDocumentTransitionInput): boolean {
	return input.animate
		&& Boolean(input.currentTheme)
		&& input.currentTheme !== input.resolvedTheme
		&& isIosWebKit();
}
